import { PersistContext } from "@/data/PersistProvider";
import { LanguageContext } from "@/data/LanguageProvider";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { ChannelRemind } from "@/utils/UrlHelper";
import React from "react";
import { Image } from "react-vant";
import MyNavLink from "../MyNavLink";
import style from "./indexProfileStyle.less";

const HomeHeaderProfile = (props) => {
  const { getPersist, setPersist } = React.useContext(PersistContext);
  const { getLanguage, langText } = React.useContext(LanguageContext);

  let history = useEnhancedHistory();
  const userInfo = getPersist("user_info");

  const backClick = () => {
    history.goBack();
  };
  const homeClick = () => {
    history.replace(ChannelRemind("/home"));
  };
  return (
    <div class={style.header_content}>
      <div class={style.profile_top_left}>
        <Image src={require("@/assets/images/header/8.png").default} />
      </div>
      {userInfo
        ? getLanguage() == "hindi"
          ? (
            <div class={style.profile_top_middle}>
              <div class={style.profile_top_userinfo} style={{textAlign:"left"}}>
                <span>{langText("profile_title_1")} {userInfo.rid}</span>
                <span style={{ marginTop: "0.3rem" }}>{langText("profile_title_2")} {userInfo.rolename}</span>
              </div>
            </div>
          ) : (
            <div class={style.profile_top_middle}>
              <div class={style.profile_top_userinfo} style={{textAlign:"left"}}>
                <span>{langText("profile_title_1")}</span>
                <span style={{ marginTop: "0.3rem" }}>{langText("profile_title_2")}</span>
              </div>
              <div class={style.profile_top_userinfo}>
                <span>{userInfo.rid}</span>
                <span style={{ marginTop: "0.3rem" }}>{userInfo.rolename}</span>
              </div>
            </div>
        ) : (
          <div class={style.profile_top_right_login_text}>
            <span>{langText("profile_title_7")}</span>
          </div>
      )}

      {userInfo ? (
        <MyNavLink to="/setting">
          <div class={style.profile_login_btn_img_setting}>
            <Image style={{ width: "2.3rem" }} src={require("@/assets/images/header/icon_profile.png").default} />
          </div>
        </MyNavLink>
      ) : (
        <MyNavLink to="/login">
          <div class={style.profile_top_right_login}>
            <div class={style.profile_login_btn}>{langText("profile_btn_12")}</div>
            <div class={style.profile_login_btn_img}>
              <img src={require("@/assets/images/header/back.png").default} />
            </div>
          </div>
        </MyNavLink>
      )}
    </div>
  );
};

export default HomeHeaderProfile;
